/* ================================================== */
/* FANCYBOX → Medias
/* ================================================== */

$(document).ready(function() {

	var medias = '[data-fancybox-type="medias"]',
		$firstVideo = $('.medias__item--video ' + medias + '[data-fancybox]');

	$(medias).fancybox({
		loop: true,
		buttons : [
			'close'
		],
		youtube: {
			rel     : 0,
			controls: 0,
			showinfo: 0,
			color   : 'fff'
		},
		vimeo: {
			byline  : false,
			title   : false,
			portrait: false,
			color   : 'fff'
		},
		afterLoad : function(instance, current) {
			if (current.opts.fancyboxMedia == 'video') {
				current.$content.css({
					overflow   : 'visible',
					background : '#000'
				});
			}
		},
		onUpdate : function(instance, current) {
			if (current.opts.fancyboxMedia == 'video') {
				var width,
					height,
					ratio = 16 / 9,
					video = current.$content;

				if (video) {
					video.hide();

					width  = current.$slide.width();
					height = current.$slide.height() - 100;

					if (height * ratio > width) {
						height = width / ratio;
					} else {
						width = height * ratio;
					}

					video.css({
						width : width,
						height: height
					}).show();
				}
			}
		}
	});

	if ($(medias).length && $firstVideo.length) {
		$('[data-fancybox-play]').click(function() { $firstVideo[0].click() });
	}

});